export const stringMapDefault = {
    close: "Close",
    helpPopover: "Help popover"
};
